import React from "react";
import PropTypes from "prop-types"
import Button from '../UI/Button/Button'

const SampleArrow = props =>{
  const { className, onClick, removeBtn, title } = props;
  return(
    <Button className={`${className} btn-disabled-${removeBtn} z-9`}
    onClick={onClick}>{title}</Button>
  )
}
 
SampleArrow.propTypes = {
  className:PropTypes.string,
  onClick:PropTypes.func,
  removeBtn:PropTypes.bool,
  title:PropTypes.string
}

export default SampleArrow;


